import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { OpenOrderTableComponent, Order } from 'gung-standard';
import { JeevesOpenOrdersListTableConfigService } from '../jeeves-open-orders-list-table-config/jeeves-open-orders-list-table-config.service';

@Injectable({
  providedIn: 'root'
})
export class JeevesOpenOrdersListConfigService extends JeevesOpenOrdersListTableConfigService {
  getLayouts(): ListLayout<Order>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => OpenOrderTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Product grid'
      }
    ];
  }
}
